import { ComponentPropsWithoutRef, FC } from 'react';

export const ProfileHeightXsIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => (
  <svg width="256" height="400" viewBox="0 0 256 400" fill="none" {...props}>
    <g clipPath="url(#clip0_3109_67920)">
      <path
        d="M134.329 361.861H4C4 382.929 21.1126 400 42.2111 400H96.1176C117.225 400 140.529 382.92 140.529 361.861H134.329Z"
        fill="#1B1F2C"
      />
      <path d="M146.596 392.698V357.299" stroke="black" strokeWidth="24.95" strokeMiterlimit="10" />
      <path d="M111.255 392.698V357.299" stroke="black" strokeWidth="24.95" strokeMiterlimit="10" />
      <path d="M161.335 352.543H96.2856V368.421H161.335V352.543Z" fill="black" />
      <path
        d="M129.094 179C151.043 179 168.873 196.788 168.873 218.704V364.284H89.3149V218.704C89.3149 196.788 107.136 179 129.094 179Z"
        fill="#1B1F2C"
      />
      <path
        d="M115.834 257.373H160.033V286.273C160.033 298.447 150.131 308.331 137.934 308.331C125.737 308.331 115.834 298.447 115.834 286.273V257.373Z"
        fill="#4CA125"
      />
      <path
        d="M129.094 188.557C146.171 188.557 160.033 202.392 160.033 219.437V262.085H98.1548V219.437C98.1548 202.392 112.017 188.557 129.094 188.557Z"
        fill="black"
      />
      <path d="M155.348 214.46H104.072V229.79H155.348V214.46Z" fill="black" />
      <path d="M152.017 302.85H123.85V364.293H152.017V302.85Z" fill="#4CA125" />
      <path
        d="M121.131 346.744C121.131 355.514 114.01 362.622 105.223 362.622C96.4363 362.622 89.3149 355.514 89.3149 346.744"
        fill="#B2FF59"
      />
      <path
        d="M152.814 374.707H135.436V400.009H178.156C178.156 386.04 166.809 374.707 152.806 374.707H152.814Z"
        fill="#1B1F2C"
      />
      <path
        d="M97.6235 227.818H165.215V292.638H141.911C117.464 292.638 97.6235 272.835 97.6235 248.435V227.818Z"
        fill="#B2FF59"
      />
      <path
        d="M140.564 228.101C140.564 239.939 130.954 248.647 119.094 248.647C107.234 248.647 97.6235 239.939 97.6235 228.101C97.6235 216.264 107.234 206.671 119.094 206.671C130.954 206.671 140.564 216.264 140.564 228.101Z"
        fill="#B2FF59"
      />
      <path
        d="M165.214 228.101C165.214 239.939 155.604 248.647 143.744 248.647C131.884 248.647 122.273 239.939 122.273 228.101C122.273 216.264 131.884 206.671 143.744 206.671C155.604 206.671 165.214 216.264 165.214 228.101Z"
        fill="#9F92FD"
      />
      <path
        d="M110.068 224.76C110.068 220.242 113.735 216.582 118.261 216.582C122.787 216.582 126.454 220.242 126.454 224.76"
        fill="#9F92FD"
      />
      <path
        d="M137.783 224.76C137.783 220.242 141.45 216.582 145.976 216.582C150.503 216.582 154.17 220.242 154.17 224.76"
        fill="#9F92FD"
      />
      <path
        d="M234.25 225.723H141.317C122.654 225.723 107.526 239.939 107.526 258.566C107.526 277.194 122.654 292.294 141.317 292.294H192.345C206.154 292.294 217.35 281.119 217.35 267.336H242.7V234.148C242.7 229.489 238.917 225.714 234.25 225.714V225.723Z"
        fill="#B2FF59"
      />
      <path
        d="M141.556 267.345L154.205 278.122L166.844 267.345L179.493 278.122L192.132 267.345L204.772 278.122L217.411 267.345L230.06 278.122L242.699 267.345"
        fill="white"
      />
      <path
        d="M237.128 236.341C237.128 240.063 234.099 243.086 230.37 243.086C226.641 243.086 223.612 240.063 223.612 236.341C223.612 232.619 226.641 230.479 230.37 230.479C234.099 230.479 237.128 232.619 237.128 236.341Z"
        fill="#B3E0DF"
      />
      <path
        d="M89.8378 221.789L79.0317 234.405L89.8378 247.02L79.0317 259.645L89.8378 272.261L79.0317 284.876L89.8378 297.501L79.0317 310.117L89.8378 322.732"
        fill="#1B1F2C"
      />
      <path
        d="M91.3082 294.371V361.861H23.6992C61.0423 361.861 91.3171 331.644 91.3171 294.371H91.3082Z"
        fill="#1B1F2C"
      />
      <path
        d="M236.198 247.109C240.344 246.57 243.55 243.033 243.55 238.746C248.218 238.746 252 242.521 252 247.18C252 251.839 248.218 255.614 243.55 255.614H235.1V255.543H219.21C214.542 255.543 210.76 251.768 210.76 247.109H236.207H236.198Z"
        fill="black"
      />
      <path
        d="M234.25 225.882H174.214V223.69C174.214 214.372 166.649 206.822 157.314 206.822H124.417C115.081 206.822 107.517 214.372 107.517 223.69V250.787C107.517 260.105 115.081 267.655 124.417 267.655H242.7V234.316C242.7 229.657 238.918 225.882 234.25 225.882Z"
        fill="white"
      />
      <path
        d="M120.21 225.794C120.21 221.276 123.877 217.616 128.403 217.616C132.929 217.616 136.596 221.276 136.596 225.794"
        fill="black"
      />
      <path
        d="M147.916 225.794C147.916 221.276 151.583 217.616 156.109 217.616C160.635 217.616 164.302 221.276 164.302 225.794"
        fill="black"
      />
      <path
        d="M204.923 247.109C200.778 246.57 197.571 243.033 197.571 238.746C192.903 238.746 189.121 242.521 189.121 247.18C189.121 251.839 192.903 255.614 197.571 255.614H206.021V255.543H221.911C226.579 255.543 230.361 251.768 230.361 247.109H204.914H204.923Z"
        fill="black"
      />
      <path d="M135.445 393.679V400H178.164C178.164 397.816 177.89 395.694 177.367 393.679H135.445Z" fill="black" />
      <path
        d="M117.384 374.707H100.006V400.009H142.725C142.725 386.04 131.379 374.707 117.375 374.707H117.384Z"
        fill="#1B1F2C"
      />
      <path d="M100.015 393.679V400H142.734C142.734 397.816 142.46 395.694 141.937 393.679H100.015Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_3109_67920">
        <rect width="248" height="221" fill="white" transform="translate(4 179)" />
      </clipPath>
    </defs>
  </svg>
);
